<template>
  <div class="container width-100 min-height flex-column justify-content-start align-items-center">
    <div
      @click="
        $router.push({
          path: '/writeOffList',
          query: {
            todayFlag: '1'
          }
        })
      "
      class="main width-100 flex-row justify-content-spaceBetween align-items-center"
    >
      <div class="width-100 flex flex-col items-center min-h-screen">
        <van-field v-model="loginForm.username" class="mt-20" label="手机号" placeholder="请输入手机号" />
        <van-field v-model="loginForm.password" label="密码" placeholder="请输入密码" type="password" />
        <div
          class="text-center text-white font-bold cursor-pointer rounded-[105px] w-[200px] h-[40px] flex flex-row items-center justify-center mt-80 text-[18px]"
          style="background: linear-gradient(to bottom, #607bef, #3974f4); color: #ffffff"
          @click="login"
        >
          登录
        </div>
      </div>
    </div>
    <!--    <img @click="handleScan" src="../../assets/image/2.png" class="btn" alt="" />-->
  </div>
</template>
<script>
export default {
  components: {},
  name: 'ipadLogin',
  data() {
    return {
      loginForm: {
        username: null,
        password: null
        // username: '13706636405', // 高郑 分管领导
        // password: '13706636405',
        // username: '13970080142', // 杨辉 信息员
        // password: '13970080142',
        // username: '18815158532', // 胡柏雄 民警
        // password: '18815158532',
      },
      count: 0,
      md5s: null,
      pubKey: null
    };
  },
  mounted() {},
  methods: {
    login() {}
  }
};
</script>

<style lang="less" scoped>
.container {
  background: url('../../assets/image/bg0.jpg') no-repeat;
  background-size: 100%;
  padding: 440px 4% 40px;
  color: rgb(247, 191, 154);
  .main {
    margin-bottom: 40px;
    .item {
      width: 33%;
      background: url('../../assets/image/3.png') no-repeat center;
      background-size: 100% 100%;
      padding: 10px 0 20px;
      p:nth-child(1) {
        font-size: 16px;
        line-height: 2rem;
      }
      p:nth-child(2) {
        font-size: 24px;
        line-height: 2rem;
      }
    }
  }
  .btn {
    max-width: 180px;
    width: 50%;
  }
}
</style>
